var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMenuIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_298",
    "data-name": "Grupo 298",
    transform: "translate(-51 -91)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_61",
    "data-name": "Rect\\xE1ngulo 61",
    width: 21,
    height: 3,
    rx: 1.5,
    transform: "translate(51 91)",
    fill: "#38291e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_62",
    "data-name": "Rect\\xE1ngulo 62",
    width: 21,
    height: 3,
    rx: 1.5,
    transform: "translate(51 97)",
    fill: "#38291e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_63",
    "data-name": "Rect\\xE1ngulo 63",
    width: 21,
    height: 3,
    rx: 1.5,
    transform: "translate(51 103)",
    fill: "#38291e"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.6402b5e5.svg";
export { ForwardRef as ReactComponent };